module.exports = __webpack_public_path__ + "./images/bcc4511334175890e3224ea57d0093b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/ac-splash-full.jpg
// module id = 597
// module chunks = 0